import Form from "../form/Form";
import { edit } from '../../slices/profileSlice';
import { superAdminUrl } from "../../utils/fetch";

function ProfileCredentials(props) {
    return (
        <Form 
            inputs={
                {
                    email: {
                        label: "Login e-mail",
                        field: "text",
                    },
                    password: {
                        label: "Password",
                        field: "password",
                    },
                    confirmPassword: {
                        label: "Confirm Password",
                        field: "password",
                    },
                }
            }
            columns={2}
            stateName="profile"
            dispatchFunc={edit}
            title={"Profile Credentials"}
            api={`${superAdminUrl}/api/cpanel-update`}
            navbar
        />
    );
}

export default ProfileCredentials;